import {
  SHOW_ALERT_NOTIFICATION
} from './constants';

export const showAlertNotification = (data) => ({
  type: SHOW_ALERT_NOTIFICATION,
  data
});

export const FOO = null;
